<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop">
        <div class="pop_tit _flex">
            <p>{{ state.boardItem.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sch_condition_wrap">
            <div class="left _column _flex">
                <div class="date_wrap">
                    <template v-if="state.boardItem.state == 2">
                        <span class="state_tag">진행중</span>
                    </template>
                    <template v-else-if="state.boardItem.state == 1">
                        <span class="state_tag waiting">대기중</span>
                    </template>
                    <template v-else>
                        <span class="state_tag finish">마감</span>
                    </template>
                    <div class="collection_period">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            모집기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.recruitStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.recruitEndDate), ".") }}</span>
                    </div>
                    <div class="end_point">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            신청종료일
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.applyDate), ".") }}</span>
                    </div>
                    <div class="activity_duration" v-if="state.boardItem.activeStartDate && state.boardItem.activeEndDate">
                        <span>
                            <img src="img/cal_icon.png" alt="" />
                            활동기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.activeStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.activeEndDate), ".") }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="sch_condition_wrap" style="border-bottom: 1px solid #d9d9d9; padding-bottom: 10px">
            <div class="left">
                <label>신청자</label>
                <p v-text="state.item.name"></p>
            </div>

            <div class="right">
                <label>선발인원</label>
                <p>{{ state.boardItem.cntApply }}/{{ state.boardItem.pickCnt ? state.boardItem.pickCnt : 0 }}</p>
            </div>
        </div>

        <div class="custom_scroll">
            <ul class="areaAnswer">
                <template v-if="state.list.length > 0">
                    <li v-for="(item, idx) in state.list" :key="idx">
                        <p v-text="idx + 1 + '. ' + item.title"></p>

                        <template v-if="item.type !== 3">
                            <ul v-if="item.type === 1">
                                <li v-for="answer in item.caseList" class="radio_wrap cnt p_5">
                                    <label :for="'radio_' + item.idx + '_' + answer.idx">
                                        <input type="radio" :id="'radio_' + item.idx + '_' + answer.idx" :checked="answer.isChecked" disabled />
                                        <em></em>
                                        <span v-html="answer.title"></span>
                                    </label>
                                </li>
                            </ul>
                            <ul v-if="item.type === 2">
                                <li v-for="answer in item.caseList" class="checkbox_wrap cnt p_5">
                                    <label :for="'chk_' + item.idx + '_' + answer.idx">
                                        <input type="checkbox" :id="'chk_' + item.idx + '_' + answer.idx" :checked="answer.isChecked" disabled />
                                        <em></em>
                                        <span v-html="answer.title"></span>
                                    </label>
                                </li>
                            </ul>
                        </template>

                        <template v-if="item.type === 3">
                            <div v-if="item.answer" v-html="item.answer"></div>
                            <div v-else v-html="'신청자가 작성한 답이 없습니다.'"></div>
                        </template>
                    </li>
                </template>
                <li v-else>
                    <div class="tb_subject" style="text-align: center; width: 100%">등록한 신청 양식이 없습니다.</div>
                </li>

                <li class="areaSign">
                    <label style="display: block">
                        서명
                        <button type="button" class="down_btn icon_wrap">
                            <img src="img/download.png" alt="" @click="exportSign(state.item.sign)" />
                        </button>
                    </label>
                    <div>
                        <img :src="state.item.sign" />
                    </div>
                </li>
            </ul>
        </div>

        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _gray" @click="isSave(1)">선발취소</button>
            <button class="submit_btn _130 _main_blue" @click="isSave(3)">임시저장</button>
            <button class="submit_btn _130 _main_blue" @click="isSave(2)">최종선발</button>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode, ModalDefault } from "@/BaseComponent";

    export default {
        props: {
            answerInfo: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                item: {} as any,
                boardItem: {} as any,
                list: [] as Array<any>,

                type: 0 as number,

                idxForRemove: 0 as number,

                itemForItem: {} as any,
                isShowCaseModal: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(() => {
                state.idx = props.answerInfo.boIdx;
                state.item = props.answerInfo;
                boardDetail();
                getList();
            });

            watch(props, () => {
                state.idx = props.answerInfo.boIdx;
                state.item = props.answerInfo;
                boardDetail();
                getList();
            });

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const boardDetail = async () => {
                const res = await apiService.board.detail(1, state.idx);
                if (res.returnCode === 0) {
                    state.boardItem = res.data;
                }
            };

            const strGubun = (val: number) => {
                switch (val) {
                    case 1:
                        return "객관식";
                    case 2:
                        return "객관식(복수)";
                    case 3:
                        return "주관식";
                    default:
                        return "";
                }
            };

            const getList = async () => {
                state.list = [];

                const res = await apiService.board.answerForForm(state.idx, state.item.meIdx);
                if (res.returnCode === 0) {
                    state.list = res.data;
                } else {
                    console.error(res.description);
                    state.list = [];
                }
            };

            const changeOrder = async (idx: number, arrow: number) => {
                const res = await apiService.board.isOrderForm(idx, arrow);
                if (res.returnCode === 0) {
                    getList();
                }
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    save();
                }
            };

            const isSave = (type: number) => {
                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 저장하시겠습니까?";
                state.isShowModal = true;

                state.type = type;
            };

            const save = async () => {
                if (state.type === 0) {
                } else {
                    const param: types.ReqBoardApplyPick = {
                        state: state.type,
                        idxList: state.item.idx,
                    };

                    const res = await apiService.board.applyPick(state.idx, param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "완료되었습니다.";
                        state.isShowModal = true;
                        emit("callback");
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }

                    state.type = 0;
                }
            };

            const exportSign = async (prop: string) => {
                try {
                    const response = await fetch(prop);
                    const blob = await response.blob();
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    const fileName = prop.split("/").pop() || "download.png";

                    a.href = downloadUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();

                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(downloadUrl);
                } catch (error) {
                    console.error("이미지 다운로드 실패:", error);
                }
            };

            return {
                state,
                props,
                CommonUtils,

                closeModal,
                strGubun,
                changeOrder,

                callBackModal,
                getList,
                isSave,
                exportSign,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk {
        max-width: 1200px;
    }
    .applicant_chk .date_wrap {
        margin: 0;
    }

    .custom_scroll {
        padding-right: 10px;
        overflow-y: auto;
        max-height: calc(100vh - 450px);
    }
    .sch_condition_wrap label {
        color: #a6a6a6;
    }

    .sch_condition_wrap p {
        font-weight: bold;
    }

    ul.areaAnswer {
        margin-top: 5px;
    }

    ul.areaAnswer > li {
        border-bottom: 1px solid #d9d9d9;
        width: 100%;
        margin-bottom: 15px;
    }

    ul.areaAnwer > li p {
        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;
        color: #252525;
    }

    ul.areaAnswer > li div {
        border: 1px solid #d9d9d9;
        padding: 10px 4px 10px 10px;
        border-radius: 5px;
        margin: 15px 0;
        color: #6d6d6d;
        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;

        line-height: 22px;
        letter-spacing: 0%;
    }

    ul.areaAnswer > li ul > li {
        margin: 15px 0;
    }

    ul.areaAnswer > li ul > li span {
        color: #6d6d6d;
    }

    ul.areaAnswer > li ul > li input + em {
        cursor: auto;
    }

    ul.areaAnswer > li ul > li input[type="checkbox"]:checked + em {
        background-color: var(--accent_color);
        border: 1px solid var(--accent_color);
    }

    ul.areaAnswer > li ul > li input[type="checkbox"]:checked + em + span {
        color: #001c92;
    }

    li.areaSign div {
        max-width: 250px;
    }

    li.areaSign div img {
        width: 100%;
        height: auto;
    }
</style>
